import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCommodityList extends Layout {
    labelPageTitle: Label;
    sourceCommodity: DataSource;
    tableCommodity: Table;
}
